import { animate, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { CacheBusterService } from './core/services/cache-buster.service';
import { Apps } from './shared/enums/enum';
import { MasterService } from './shared/services/master.service';
import { SharedService } from './shared/services/shared.service';
import { ToasterService } from './shared/services/toaster.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.css',
  animations: [
    trigger('toastAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 })),
      ]),
    ]),
  ],
})
export class AppComponent {
  title = 'InventoryMgmt.Web';
  successMsg: string = '';
  clientErrorMsg: string = '';
  serverErrorMsg: string = '';
  processMsg: string = '';
  showSuccess: boolean = false;
  showClientError: boolean = false;
  showServerError: boolean = false;
  showProcessing: boolean = false;
  userDetails: any;

  private successTimeout: any;
  private clientErrorTimeout: any;
  private serverErrorTimeout: any;
  private readonly subscriptions: Subscription[] = [];
  cookieService: any;
  constructor(
    private readonly toast: ToasterService,
    private masterService: MasterService,
    private sharedService: SharedService,
    private cacheBuster: CacheBusterService,
  ) {}

  ngOnInit() {
    this.setupToastListeners();
    this.handleBrowserRefresh();
    try {
      this.cacheBuster.init();
    } catch (err) {
      console.error('CacheBuster init failed:', err);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.successTimeout) {
      clearTimeout(this.successTimeout);
    }
    if (this.clientErrorTimeout) {
      clearTimeout(this.clientErrorTimeout);
    }
    if (this.serverErrorTimeout) {
      clearTimeout(this.serverErrorTimeout);
    }
  }

  private setupToastListeners() {
    this.subscriptions.push(
      this.toast.successMessage$.subscribe((msg) => {
        if (msg) {
          if (this.successTimeout) {
            clearTimeout(this.successTimeout);
          }

          this.successMsg = msg;
          this.showSuccess = true;
          this.successTimeout = setTimeout(() => {
            this.showSuccess = false;
          }, 3000);
        }
      }),
    );

    this.subscriptions.push(
      this.toast.clientErrorMessage$.subscribe((msg) => {
        if (msg) {
          if (this.clientErrorTimeout) {
            clearTimeout(this.clientErrorTimeout);
          }

          this.clientErrorMsg = msg;
          this.showClientError = true;
          this.clientErrorTimeout = setTimeout(() => {
            this.showClientError = false;
          }, 5000);
        }
      }),
    );

    this.subscriptions.push(
      this.toast.serverErrorMessage$.subscribe((msg) => {
        if (msg) {
          if (this.serverErrorTimeout) {
            clearTimeout(this.serverErrorTimeout);
          }

          this.serverErrorMsg = msg;
          this.showServerError = true;
          this.serverErrorTimeout = setTimeout(() => {
            this.showServerError = false;
          }, 6000);
        }
      }),
    );
    this.subscriptions.push(
      this.toast.processMessage$.subscribe((msg) => {
        this.processMsg = msg;
        this.showProcessing = !!msg;
      }),
    );
  }
  private handleBrowserRefresh() {
    const perfEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];

    if (perfEntries.length && perfEntries[0].type === 'reload') {
      this.onBrowserRefresh();
    }
  }
  onBrowserRefresh(): void {
    if (!this.userDetails) {
      return;
    }

    let appId = Apps.IMS;
    this.masterService.userPermissions = [];
    this.masterService.rolesLoaded = false;
    this.masterService.getRolesandPerm(appId);
    this.sharedService.getApps().subscribe();
    this.sharedService.getCompanyApps(this.userDetails.companyid);
  }

  closeSuccessToast() {
    if (this.successTimeout) {
      clearTimeout(this.successTimeout);
    }
    this.showSuccess = false;
  }
  closeClientErrorToast() {
    if (this.clientErrorTimeout) {
      clearTimeout(this.clientErrorTimeout);
    }
    this.showClientError = false;
  }
  closeServerErrorToast() {
    if (this.serverErrorTimeout) {
      clearTimeout(this.serverErrorTimeout);
    }
    this.showServerError = false;
  }

  closeProcessingToast() {
    this.toast.process('');
  }
}
